<template>
  <div>
    <WCCheckoutGiftCardLineItem
      v-for="giftCardItem in giftCardItems"
      :key="giftCardItem.id"
      :giftCard="giftCardItem"
    />
  </div>
</template>

<script>
import WCCheckoutGiftCardLineItem from '../WCCheckoutGiftCardLineItem/WCCheckoutGiftCardLineItem.vue';

export default {
  name: 'WCCheckoutGiftCardLineItems',
  components: { WCCheckoutGiftCardLineItem },
  props: {
    giftCardItems: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
